// frontend/src/components/auth/RequireEmpresaAll.tsx
// Guard de ruta: solo usuarios con rol Empresa.All ("all") pueden acceder.
// Usa el mismo query ['auth-me'] que useIsEmpresaAll para esperar a que resuelva
// (no redirige durante la carga, así no expulsa a un "all" en un refresh directo).
import { useQuery } from '@tanstack/react-query'
import { Navigate, Outlet } from 'react-router-dom'
import { authApi } from '@/services/api'

export function RequireEmpresaAll() {
  const { data, isLoading } = useQuery({
    queryKey: ['auth-me'],
    queryFn: authApi.getMe,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
  })
  if (isLoading) return null
  if (!data?.isEmpresaAll) return <Navigate to="/home" replace />
  return <Outlet />
}
